export const SUCCESS = 'success';
export const ERROR = 'danger';
export const INFO = 'info';
export const WARNING = 'caution';

export default {
    [INFO]: {
        textColor: 'bg-gray-900 text-white',
        actionButtons:
            'bg-gray-900 text-gray-400 hover:bg-gray-800 hover:bg-opacity-30 active:bg-gray-800 active:bg-opacity-75',
        divider: 'divide-gray-400',
        closeIcon: 'white',
        border: 'border-gray-400',
        close: 'text-white hover:text-opacity-80 active:text-gray-400',
    },
    [ERROR]: {
        textColor: 'bg-red-100 text-red-600',
        actionButtons:
            'hover:bg-red-200 hover:bg-opacity-30 active:bg-red-200 text-red-600 active:bg-opacity-75 bg-red-100',
        divider: 'divide-red-300',
        closeIcon: 'red',
        border: 'border-red-300',
        close: 'text-red-600 hover:text-opacity-80 active:text-red-900',
    },
    [WARNING]: {
        textColor: 'bg-orange-100 text-orange-550',
        actionButtons:
            'hover:bg-orange-200 hover:bg-opacity-30 active:bg-orange-200 text-orange-550 active:bg-opacity-75 bg-orange-100',
        divider: 'divide-orange-550',
        border: 'border-orange-550',
        close: 'text-gray-800 hover:text-gray-700 active:text-black',
    },
    [SUCCESS]: {
        textColor: 'bg-green-100 text-green-700',
        actionButtons:
            'hover:bg-green-200 hover:bg-opacity-30 active:bg-green-200 text-green-700 active:bg-opacity-75 bg-green-100',
        divider: 'divide-green-700',
        border: 'border-green-700',
        close: 'text-gray-800 hover:text-gray-700 active:text-black',
    },
};
